export const defaultLineStyle = {
  width: 1,
  alpha: 1,
  color: 0xf0f0f0,
  alignment: 1,
  pixelLine: true,
};
